import { InitOptions } from 'i18next'
import conjunctionFormat from './conjunctionFormat'

export const initOptions: InitOptions = {
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en'],
  // loadPath: 'online/locales/{{lng}}/{{ns}}.json',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    format: (value: Iterable<string>, format?: string, language?: string): string => {
      if (format === 'and') return conjunctionFormat(value, language as Intl.Locale | undefined)
      return value as string
    },
  },
}
